import { useEffect, useState } from "react";
import { Form } from "../../common/Form";
import { ButtonMenu } from "../../common/ButtonMenu";
import { Button } from "primereact/button";
import { RubricDialog } from "./Rubric";
import CmsService from "../../../service/CmsService";
import { useTranslation } from "react-i18next";

export function QueScoring({scoreInfo,onChange})
{
    const {t}=useTranslation();
    const [scrInfo,setScrInfo]=useState(scoreInfo?{...scoreInfo}:{});
    const [rubrics,setRubrics]=useState([]);
    const [rubricDialogVisible,setRubricDialogVisible]=useState(false);
    const [currentRubric,setCurrentRubric] = useState(scoreInfo?scoreInfo.rubric:null);

    const scoreMethods = [
        {label: t('AVERAGE'), value:'AVERAGE'},
        {label: t('MEAN'), value:'MEAN'}
        ];    
    const _onChange=(scr)=>{
        setScrInfo(scr);
        onChange(scr);
    }
    const onAddRubric=()=>{
        if(scrInfo.rubricId == 0) //private?
        {
            setCurrentRubric(scrInfo.rubric);
            setRubricDialogVisible(true);
        }
        else if(scrInfo.rubricId>0)
        {
            CmsService.getRubric(scrInfo.rubricId).then((ret)=>{
                setCurrentRubric(ret);
                setRubricDialogVisible(true);    
            });
        }
        else
        {
            setCurrentRubric(null);
            setRubricDialogVisible(true);
        }
    }
    const onRubricOK=(rubric)=>{        
        if(!rubric.private)
        {
            if(rubric.id>0)
            {
                CmsService.updateRubric(rubric).then((ret)=>{
                    retrieveRubrics(ret);
                    setRubricDialogVisible(false);          
                });    
            }
            else
            {
                CmsService.createRubric(rubric).then((ret)=>{
                    retrieveRubrics(ret);
                    setRubricDialogVisible(false);          
                });    
            }
        }
        else
        {
            var sc={...scrInfo};
            sc.rubric = rubric;
            sc.rubricId = 0;
            if(rubrics.findIndex((item)=>item.id == 0)<0)
            {
                var rbr=[...rubrics];
                rbr.push({name:'<Private>',id:0});
                setRubrics(rbr);    
            }
            setScrInfo(sc);
            setRubricDialogVisible(false);
        }
    }
    const onRubricCancel=()=>{setRubricDialogVisible(false)}

    const retrieveRubrics=(id)=>{
        CmsService.getRubrics().then((ret)=>{
            ret.push({id:0,name:'<Private>'});
            setRubrics(ret);
        });
    }
    useEffect(()=>{
        retrieveRubrics();
    },[scoreInfo]);
    const rubricValueTemplate=(item)=>{
        if(item == null)
            return t("<None>");
        return item.name;
    }
    return(
        <>
            <div className="grid pt-4">
                <div className="md:col-8">
                <Form id="queScoring" formData={scrInfo} columns="2" onChange={_onChange}
                    fields={[
                        {id:"rubricId",ftype:"dropdown",field:"rubricId",label:t("Rubric"),options:rubrics,
                            optionValue:"id",optionLabel:"name",valueTemplate:rubricValueTemplate,onAdd:onAddRubric},
                        {id:"scorers",ftype:"number",field:"scorers",label:t("Number_of_scorers"),steps:1},
                        {id:"reviewLimit",ftype:"number",field:"reviewLimit",label:t("Difference_limit_for_review"),steps:1},
                        {id:"scoreMethod",ftype:"dropdown",field:"scoreMethod",label:t("Score_Method"),options:scoreMethods}
                    ]}>
                </Form>	        
                </div>
            </div>
            <RubricDialog visible={rubricDialogVisible} currentRubric={currentRubric} onOK={onRubricOK} onCancel={onRubricCancel}/>
        </>
    );
}